import dateHelper from '$$dateFormatsHelper';

function getWeekScale() {
  return {
    unit: 'week',
    step: 1,
    index: 1,
    template(ndate) {
      const nday = ndate.getDay();
      const first_thursday = new Date(ndate.valueOf());

      first_thursday.setDate(ndate.getDate() + (4 - nday));

      const year_number = first_thursday.getFullYear(); // year of the first Thursday
      const ordinal_date = Math.round((first_thursday.getTime() - new Date(year_number, 0, 1).getTime()) / 86400000); // ordinal date of the first Thursday - 1 (so not really ordinal date)
      const week_number = 1 + Math.floor(ordinal_date / 7);

      const startDateDay = ndate.getDate();
      const endDate = ndate;

      endDate.setDate(endDate.getDate() + 6);
      const endDateDay = endDate.getDate();

      return `<span title="${__('days_week_range')}">${startDateDay}-${endDateDay}</span>&nbsp;<span title="${__('week_number')}">(${week_number}${__('week_in_time_string')})</span>`;
      // return week_number + " " + __('gantt_week');
    },
  };
}

export default function (instance) {
  const locale = user.locale;

  return {
    levels: [
      {
        name: 'hour',
        scale_height: 38,
        min_column_width: 20,
        scales: [
          { unit: 'day', step: 1, format: locale === 'en' ? '%M %d' : '%d %M' },
          { unit: 'hour', step: 1, format: !dateHelper.getUserTimeFormat() ? '%h' : '%H' },
        ],
      },
      {
        name: 'day',
        scale_height: 38,
        min_column_width: 26,
        scales: [
          { unit: 'month', step: 1, date: '%F %Y' },
          {
            unit: 'day',
            step: 1,
            date: '%d',
            css(date) {
              if (!instance.isWorkDay(date)) {
                return ' weekend';
              }

              return '';
            },
          },
        ],
      },
      {
        name: 'week',
        scale_height: 38,
        min_column_width: 70,
        scales: [
          { unit: 'month', step: 1, date: '%F %Y' },
          getWeekScale(),
        ],
      },
      {
        name: 'month',
        scale_height: 38,
        min_column_width: 65,
        scales: [
          { unit: 'year', step: 1, format: '%Y' },
          { unit: 'month', step: 1, format: '%M' },
        ],
      },
      {
        name: 'quarter',
        height: 38,
        min_column_width: 45,
        scales: [
          { unit: 'quarter', step: 1, format: date => `${__('settings_quarter')} ${Math.ceil((date.getMonth() + 1) / 3)}, ${date.getFullYear()}` },
          { unit: 'month', step: 1, format: '%M' },
        ],
      },
      {
        name: 'year',
        scale_height: 38,
        min_column_width: 45,
        scales: [
          { unit: 'year', step: 1, format: '%Y' },
        ],
      },
    ],
  };
}
